/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import IconCardCarousel from '../../components/IconCardCarousel';
import ICCImg from '../../../../../../assets/student-training/ctis/img1.png';
import MisconceptionCards, {
  MISCONCEPTION_CARD_ICONS,
} from '../../components/MisconceptionCards';
import SafeBrowsing from '../../components/SafeBrowsing';
import { ICC_ICONS, MC_ICON } from './iconMap';
import step1 from '../../../../../../assets/student-training/ctis/step1.png';
import step2 from '../../../../../../assets/student-training/ctis/step2.png';
import step3 from '../../../../../../assets/student-training/ctis/step3.png';
import step4 from '../../../../../../assets/student-training/ctis/step4.png';

const stepIconMap: Record<number, string> = {
  1: step1,
  2: step2,
  3: step3,
  4: step4,
};

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const updateComponentState = useUpdateComponentState();
  const handleIntegratedServiceListComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-cits-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

   const ICCItems =
    paragraphsSettings?.ICCItems?.map((item: any, index: number) => ({
      icon: ICC_ICONS[index](false),
      title: item.title,
      content: item.content,
    })) ?? [];

  return (
    <div className="topic-section-1">
      <IconCardCarousel
        mainTitle={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.ICCTitle}
        description={paragraphsSettings?.ICCDesc}
        items={ICCItems}
        illustration={<img src={ICCImg} alt="" />}
        defaultActive={5}
      />
      <MisconceptionCards
        subTitle={paragraphsSettings?.MCTitle}
        items={paragraphsSettings?.MCItems}
        tips={paragraphsSettings?.MCDesc}
        icons={MC_ICON}
        id="student-training-cits-section1-1"
        onComplete={handleIntegratedServiceListComplete}
      />
      <SafeBrowsing
        subTitle={paragraphsSettings.SBTitle}
        slides={paragraphsSettings.SBItems}
        icons={stepIconMap}
      />
    </div>
  );
};

export default Section1;
